import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_techno_cube_green/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-266a641d66.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-97e2f58cbf.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-7e2b2ff759.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-cf618fa579.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-97af6608c2.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-2fca5f6ee7.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-47270b7469.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-e5cb5b125c.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-41f8260049.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-6f45d76e3e.png'; };
